import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"sensors-2"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4.92893 4.92871C3.11929 6.73835 2 9.23835 2 11.9998C2 14.7613 3.11933 17.2613 4.92904 19.071M7.75736 7.75684C6.67157 8.84262 6 10.3426 6 11.9995C6 13.6564 6.67162 15.1564 7.75747 16.2422M12 10V14M16.2423 7.75684C17.3281 8.84262 17.9997 10.3426 17.9997 11.9995C17.9997 13.6564 17.328 15.1564 16.2422 16.2422M19.0714 4.92871C20.881 6.73835 22.0003 9.23835 22.0003 11.9998C22.0003 14.7613 20.881 17.2613 19.0713 19.071","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Sensors2 = Vue.extend<IconProps>({
  name: 'Sensors2Icon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'sensors-2',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Sensors2;
